export const envTypeEnvVarName = "REACT_APP_ENV_TYPE";
export const envTypeDev = "development";
export const envTypeStaging = "staging";
export const envTypeProd = "production";
export const isDownloadContextOnLlmCallEnvVarName = "REACT_APP_IS_DOWNLOAD_CONTEXT_ON_LLM_CALL";

// this is not valid App Environment Type, used only for logging purposes
export const envTypeSandbox = "sandbox";

export function isDownloadContextOnLlmCall(): boolean {
  return getEnvVar(isDownloadContextOnLlmCallEnvVarName) === "true";
}

export function getEnvType(): string {
  return getEnvVarOrFail(envTypeEnvVarName);
}

export function isDevEnv(): boolean {
  return getEnvType() === envTypeDev;
}

export function getEnvVar(varName: string): string | undefined {
  return process.env[varName];
}

export function isProdEnv(): boolean {
  return getEnvType() === envTypeProd;
}

export function isStagingEnv(): boolean {
  return getEnvType() === envTypeStaging;
}

export function getEnvVarOrFail(varName: string): string {
  const value = getEnvVar(varName);
  if (!value || value.trim().length < 1) {
    throw new Error(`Missing ${varName} env var`);
  }
  return value;
}

export function bytesToSize(bytes: number) {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "n/a";
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  if (i === 0) return `${bytes} ${sizes[i]})`;
  return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
}

export function isNoAccessError(status: number) {
  return status === 403;
}

const websiteValidationRegex =
  /^(?:http:\/\/|https:\/\/)?[\w\d]+(?:[-.]{1}[\w\d]+)*\.[\w]{2,20}(?::[\d]{1,20})?(?:\/\S*)?$/;

export function validateWebsite(website: string): boolean {
  const isWebsiteValid = websiteValidationRegex.test(website);

  return isWebsiteValid;
}

export type StringLimitMode = "left-to-right" | "right-to-left";
export function limitStringLength<T extends string | undefined>(
  value: T,
  max = 255,
  suffix = "...",
  mode: StringLimitMode = "left-to-right"
): T {
  if (!value) return value;
  if (mode === "right-to-left") {
    return (
      value.length > max && value.length > suffix.length
        ? suffix + value.substring(value.length - max)
        : value
    ) as T;
  }
  return (
    value.length > max && value.length > suffix.length
      ? value.substring(0, max - suffix.length) + suffix
      : value
  ) as T;
}
